
import React, { Component } from 'react';
import CdnImage from '../../components/cdnImage/cdnImage.js'
import { Container, Row } from 'reactstrap';
import ErrorComponent from '../../components/error/ErrorComponent'
import LoadingComponent from '../../components/loading/LoadingComponent'

const compareVersions = require('compare-versions').compareVersions;
const rmsApiProxyRetry = require('../../utils/api/rmsApiProxyRetry');
const queryString = require('query-string').default;
const themeUtil = require('../../utils/view/themeUtil');
const stateManager = require('../../utils/state/stateManager.js');
const constants = require('../../utils/domain/constants.js');
const stringUtil = require('../../utils/string/stringUtil.js');
const configurationManager = require('../../utils/config/configurationManager.js');
const uiConstants = require('../../utils/domain/uiConstants.js');
const logger = require('../../utils/logger/logger.js');
const dateUtil = require('../../utils/dateUtil/dateUtil.js');
const commonUtility = require('../../utils/domain/commonUtility');
const translator = require('../../utils/translator/translator')
const terminalSettingsUtils = require('../../utils/domain/settings/terminalSettingsUtils.js')
var creditCardTerminalDriver = require('../../utils/creditCardTerminal/creditCardTerminalDriver.js');
const localizationUtils = require('../../utils/domain/localizationUtils.js')
var notificationChannel = require('../../utils/messaging/notification/notificationChannel.js');
var salesChannel = require('../../utils/messaging/sales/salesChannel.js');
var salesLoader = require('../../utils/domain/sales/salesLoader');
var beamerUtils = require('../../utils/beamer/beamerUtils.js');
const passportAction = require('../../utils/state/actions/passport/passportAction.js');
const userNotificationsUtil = require('../../utils/userNotifications/userNotificationsUtil.js');

class LoadingView extends Component 
{
    constructor(props)
    {
        super(props);

        this.state = {};
        this.state.stage = 0;
        this.state.error = null;

        this.state.appId = null;
        this.state.appIdDecoded = false;
        this.state.browserShellTypeAllowed = false;

        this.initializeHost();
    }


    render()
    {
        var cloudName = configurationManager.getConfig().cdnAppCloudName;
        
        if (stringUtil.isStringNullOrEmpty(this.state.appId) || this.state.appIdDecoded)
        {
            if (stringUtil.areStringSame(stateManager.getStore().getState().shellType, uiConstants.BrowserShellType) &&
                !this.state.browserShellTypeAllowed)
            {
                return (
                            <div style={{paddingTop:'200px'}}>
                                <CdnImage cloudName={cloudName} height={200} publicId={themeUtil.getLoadingViewLogo()}/>
                                <div style={{marginTop:'25px', textAlign:'center'}}>
                                    <h2>{translator.getLabel("pos_is_accessed_within_browser")}</h2>
                                    {translator.getLabel("please_use_shell_to_access_pos")}<br/>
                                    {translator.getLabel("for_any_further_assistance_please_contact_help_desk_at")}
                                </div>
                            </div>
                        )
            }

            if (stringUtil.isStringNullOrEmpty(stateManager.getStore().getState().terminalCode))
            {
                var errorMessage = translator.getLabel("please_specify_your_terminal_code_as_part_of_url");
                if (!stringUtil.isStringNullOrEmpty(this.state.appId))
                {
                    errorMessage = translator.getLabel("app_Id_is_either_invalid_or_is_expired");
                }

                return (
                        <div style={{paddingTop:'200px'}}>
                            <CdnImage cloudName={cloudName} height={200} publicId={themeUtil.getLoadingViewLogo()}/>
                            <div style={{marginTop:'25px', textAlign:'center'}}>
                                <h2>{translator.getLabel("pos_is_accessed_without_terminal_code")}</h2>
                                {errorMessage}.<br/>
                                {translator.getLabel("for_any_further_assistance_please_contact_help_desk_at")}
                            </div>
                        </div>
                        )
            }
        }

        return this.renderLoadingStage();
    }

    renderLoadingStage()
    {
        var cloudName = configurationManager.getConfig().cdnAppCloudName;
        
        if (stringUtil.isStringNullOrEmpty(this.state.error))
        {
            if (this.state.stage == 0)
            {
                this.loadEnvironment();
            }

            else if (this.state.stage == 1)
            {
                this.loadConfiguration();
            }

            else if (!stringUtil.isStringNullOrEmpty(this.state.appId) && !this.state.appIdDecoded)
            {
                this.renderUrlDecodingStage()
            }

            else if (this.state.stage == 2)
            {
                this.verifyingVersion();
            }
            
            else if (this.state.stage == 3)
            {
                this.renderPassportAcquiringStage();
            }

            else if (this.state.stage == 4)
            {
                this.renderOrgLoadingStage()
            }

            else if (this.state.stage == 5)
            {
                this.renderLookupsLoadingStage()
            }

            else if (this.state.stage == 6)
            {
                this.renderStaffLoadingStage()
            }

            else if (this.state.stage == 7)
            {
                this.renderMenuLoadingStage()
            }

            else if (this.state.stage == 8)
            {
                this.renderSnoozeLoadingStage()
            }

            else if (this.state.stage == 9)
            {
                this.renderPromotionsDataStage()
            }

            else if (this.state.stage == 10)
            {
                this.renderTerminalProfileStage()
            }

            else if (this.state.stage == 11)
            {
                this.renderTerminalIntegrationsStage();
            }

            else if (this.state.stage == 12)
            {
                this.renderFloatSessionLoadingStage()
            }

            else if (this.state.stage == 13)
            {
                this.renderAccountModulesLoadingStage()
            }

            else if (this.state.stage == 14)
            {
                this.renderOrderNumberFountainStage()
            }

            else if (this.state.stage == 15)
            {
                this.renderPrintingTemplateLoadingStage();
            }

            else if (this.state.stage == 16)
            {
                this.renderLanguageLoadingStage()
            }

            else if (this.state.stage == 17)
            {
                this.renderVerifyConfigurations()
            }

            else if (this.state.stage == 18)
            {
                this.renderSalesLoadStage()
            }

            else if (this.state.stage == 19)
            {
                this.renderUserNotifications()
            }

            else if (this.state.stage == 20)
            {
                this.renderNotificationsLoadStage()
            }

            else if (this.state.stage == 21)
            {
                this.renderNotificationChannelConnection()
            }

            else if (this.state.stage == 22)
            {
                this.renderSalesChannelConnection()
            }
            
            else if (this.state.stage == 23)
            {
                this.renderCreditCardTerminalConnection();
            }

            else if (this.state.stage == 24)
            {
                this.loadSystemTheme()
            }

            else
            {
                logger.info("Application loaded successfully");
                beamerUtils.initializeBeamer();
                var passport = stateManager.getStore().getState().passport;
                stateManager.getStore().getState().applicationInitialized = true;
                stateManager.getStore().getState().applicationInitializationDateTime = dateUtil.getNow();
                stateManager.getStore().dispatch(passportAction.createAction(passport));
                return null;
            }
        }

        return (<div className='h-100 d-flex justify-content-center align-items-center'>
            <Container>

                <CdnImage cloudName={cloudName} height={150} publicId={themeUtil.getLoadingViewLogo()}/>    
                {
                    this.state.error == null 
                    ? 
                    <LoadingComponent waitMessage="Loading"/>
                    
                    : 
                    this.renderErrorStage()
                }
            </Container>
        </div>);
    }

    renderErrorStage()
    {
        return (<div style={{marginTop:'20px'}}><ErrorComponent error={this.state.error}/></div>);
    }

    loadEnvironment()
    {
        var completeUrl = `/environment.json`;

        fetch(completeUrl, {cache: "no-store"})
        .then (async response =>
        {
            if (response.status != 200)
            {
                var errorMessage = `Error occurred while loading environment configuration. The returned code is ${response.status}`;
                logger.error(errorMessage);
                this.setState({
                                error: errorMessage
                              });
                return;
            }

            var environmentConfiguration = await response.json();
            configurationManager.setEnvironment(environmentConfiguration.environment, environmentConfiguration.environmentConfigServiceUrl);
            this.state.stage = this.state.stage + 1;
            this.setState({});

        }, error =>
        {
            var errorMessage = `Error occurred while loading environment configuration ${error}`;
            logger.error(errorMessage, {}, error);
            this.setState({
                            error: errorMessage
                            });
            return;
        });
    }

    loadConfiguration()
    {
        configurationManager.loadConfiguration()
        .then (results =>
            {
                logger.resetGlobalContext();
                this.state.stage = this.state.stage + 1;
                this.setState({});
            }, error =>
            {
                var errorMessage = `Error occurred while loading configuration ${error}`;
                logger.error(errorMessage, {}, error);
                this.setState({
                                error: errorMessage
                                });
                return;
            });
    }

    renderUrlDecodingStage()
    {
        var url = `core/system/security/urlDecoder?encodedUrl=${this.state.appId}`;
        rmsApiProxyRetry.get(url)
        .then(result =>
            {
                if (result != null && !stringUtil.isStringNullOrEmpty(result.terminalCode))
                    stateManager.getStore().getState().terminalCode = result.terminalCode;
                this.state.appIdDecoded = true;
                this.setState({});
            }, error =>
            {
                logger.error(`Error occurred while decoding ${error}`, null, error );
                this.state.appIdDecoded = true;
                this.setState({});
            });
    }

    verifyingVersion()
    {
        var config = configurationManager.getConfig();
        
        if (!stringUtil.isStringNullOrEmpty(config.appPOSVersion) && 
            compareVersions(config.appPOSVersion, config.version) == 1)
        {
            logger.warn(`Remote version (${config.appPOSVersion}) is higher than local version (${config.version}). Needs to reload app without cache`);
            window.location.reload();
            return;
        }

        this.state.stage = this.state.stage + 1;
        this.setState({});
    }

    renderPassportAcquiringStage()
    {
        rmsApiProxyRetry.post(`core/system/security/authenticateTerminal?terminalCode=${stateManager.getStore().getState().terminalCode}`)
                .then(response =>
                    {
                        stateManager.getStore().getState().passport = response;
                        stateManager.getStore().getState().passportExpired = false;

                        logger.info("Terminal Passport acquired successfully");
                        this.state.stage = this.state.stage + 1;
                        this.setState({});
                    },
                    error =>
                    {
                        if (error == '401')
                        {
                            logger.error("Authentication Error while acquiring passport for terminal.");
                            this.setState({
                                            error: `Authentication Failed for terminal Id: ${stateManager.getStore().getState().terminalCode}`
                                          });
                        }
                        else
                        {
                            logger.error("Error occurred while acquiring passport for terminal. " + error, {}, error);
                            this.setState({
                                            error: error
                                          });
                        }
                    });
    }

    renderOrgLoadingStage()
    {
        rmsApiProxyRetry.get('core/organizations')
        .then(async (result) =>
        {
            const { franchisorId, franchiseeId, id: propertyId } = result.properties[0];

            let resource = `core/organizations/${franchisorId}/configurations/operatingConfiguration`;
            const franchisorOperatingConfiguration = await rmsApiProxyRetry.get(resource);

            resource = `core/organizations/${franchisorId}/${franchiseeId}/${propertyId}/licenseSubscriptions`;
            const propertyLicenseSubscriptions = await rmsApiProxyRetry.get(resource);

            resource = `core/organizations/${franchisorId}/${franchiseeId}/${propertyId}/localizations?resolved=true`;
            const propertyResolvedLocalizationSettings = await rmsApiProxyRetry.get(resource);

            resource = `core/organizations/${franchisorId}/${franchiseeId}/${propertyId}/storefronts`;
            const propertyStorefronts = await rmsApiProxyRetry.get(resource);

            resource = `core/organizations/${franchisorId}/${franchiseeId}/${propertyId}/configurations/operatingConfiguration`;
            const propertyOperatingConfiguration = await rmsApiProxyRetry.get(resource);

            resource = `core/organizations/${franchisorId}/${franchiseeId}/${propertyId}/configurations/floatConfiguration`;
            const propertyFloatConfiguration = await rmsApiProxyRetry.get(resource);

            resource = `core/organizations/${franchisorId}/${franchiseeId}/${propertyId}/configurations/printConfiguration`;
            const propertyPrintConfiguration = await rmsApiProxyRetry.get(resource);

            resource = `core/organizations/${franchisorId}/${franchiseeId}/${propertyId}/configurations/layoutConfiguration`;
            const propertyLayoutConfiguration = await rmsApiProxyRetry.get(resource);

            resource = `core/organizations/${franchisorId}/${franchiseeId}/${propertyId}/configurations/addressOverrides`;
            const propertyAddressOverrides = await rmsApiProxyRetry.get(resource);

            resource = `core/organizations/${franchisorId}/${franchiseeId}/${propertyId}/storefronts/configurations/operatingConfigurations`;
            const propertyStorefrontOperatingConfigurations = await rmsApiProxyRetry.get(resource);

            resource = `core/organizations/${franchisorId}/${franchiseeId}/${propertyId}/storefronts/configurations/deliveryCharges`;
            const propertyStorefrontDeliveryChargesConfigurations = await rmsApiProxyRetry.get(resource);

            resource = `core/organizations/${franchisorId}/${franchiseeId}/${propertyId}/storefronts/configurations/timingConfigurations`;
            const propertyStorefrontTimingsConfigurations = await rmsApiProxyRetry.get(resource);

            resource = `core/organizations/${franchisorId}/${franchiseeId}/${propertyId}/storefronts/configurations/webAppConfigurations`;
            const propertyStorefrontWebAppConfigurations = await rmsApiProxyRetry.get(resource);

            this.enrichStorefronts(propertyStorefronts, propertyStorefrontOperatingConfigurations, propertyStorefrontDeliveryChargesConfigurations, propertyStorefrontTimingsConfigurations, propertyStorefrontWebAppConfigurations)

            result.franchisors[0].operatingConfiguration = franchisorOperatingConfiguration;
            result.properties[0].subscriptions = propertyLicenseSubscriptions;
            result.properties[0].resolvedLocalizationSettings = propertyResolvedLocalizationSettings;
            result.properties[0].storefronts = propertyStorefronts;
            result.properties[0].operatingConfiguration = propertyOperatingConfiguration;
            result.properties[0].floatConfiguration = propertyFloatConfiguration;
            result.properties[0].printConfiguration = propertyPrintConfiguration;
            result.properties[0].layout = propertyLayoutConfiguration && propertyLayoutConfiguration.layout;
            result.properties[0].addressOverrides = propertyAddressOverrides;
            
            result.franchisees[0].isEnabled = true;

            const orgData = stateManager.getStore().getState().orgData;
            orgData.franchisor = result.franchisors[0];
            orgData.franchisee = result.franchisees[0];
            orgData.property = result.properties[0];

            logger.attachOrgToGlobalContext();

            logger.info("Org data loaded successfully");
            this.state.stage = this.state.stage + 1;
            this.setState({});

        })
        .catch(error =>
        {
            logger.error("Error occurred while loading Org Data." + error, {}, error);
            this.setState({ error: `Failed to load org data with error ${error}` });
        });
    }
    
    enrichStorefronts(storefronts, storefrontOperatingConfigurations, storefrontDeliveryChargesConfigurations, storefrontTimingConfigurations, storefrontWebAppConfigurations)
    {
        storefronts.forEach(storefront => {
            let operatingConfiguration = storefrontOperatingConfigurations.find(operatingConfiguration => stringUtil.areStringSame(operatingConfiguration.storefrontId, storefront.id));
            if(operatingConfiguration)
                storefront.operatingConfiguration = operatingConfiguration;
            else 
                storefront.operatingConfiguration = null;
        })

        storefronts.forEach(storefront => {
            let deliveryChargesConfiguration = storefrontDeliveryChargesConfigurations.find(deliveryCharges => stringUtil.areStringSame(deliveryCharges.storefrontId, storefront.id));
            if(deliveryChargesConfiguration)
                storefront.deliveryChargesConfiguration = deliveryChargesConfiguration;
            else 
                storefront.deliveryChargesConfiguration = null;
        })

        storefronts.forEach(storefront => {
            let timingConfigurations = storefrontTimingConfigurations.find(timingConfigurations => stringUtil.areStringSame(timingConfigurations.storefrontId, storefront.id));
            if(timingConfigurations)
                storefront.timingConfigurations = timingConfigurations;
            else 
                storefront.timingConfigurations = null;
        })

        storefronts.forEach(storefront => {
            let webAppConfiguration = storefrontWebAppConfigurations.find(webAppConfiguration => stringUtil.areStringSame(webAppConfiguration.storefrontId, storefront.id));
            if(webAppConfiguration)
                storefront.webAppConfiguration = webAppConfiguration;
            else 
                storefront.webAppConfiguration = null;
        })
    }

    renderLookupsLoadingStage()
    {
        const getLookups = async () => {
                                            const promises = 
                                            [
                                                rmsApiProxyRetry.get('core/system/lookups/venues'),
                                                rmsApiProxyRetry.get(`${rmsApiProxyRetry.getFranchisorOrgContextUrl()}/lookups/tags`),
                                                rmsApiProxyRetry.get(`${rmsApiProxyRetry.getFranchisorOrgContextUrl()}/lookups/guests`),
                                                rmsApiProxyRetry.get(`${rmsApiProxyRetry.getFranchisorOrgContextUrl()}/lookups/freebieReasons`),
                                                rmsApiProxyRetry.get(`${rmsApiProxyRetry.getFranchisorOrgContextUrl()}/lookups/kitchenStationProfiles`),
                                            ];

                                            const results = await Promise.all(promises);

                                            let result = {};
                                            result.venues = results[0];
                                            result.tags = results[1];
                                            result.guests = results[2];
                                            result.freebieReasons = results[3];
                                            result.kitchenStationProfiles = results[4];

                                            return result;
                                    }

        getLookups()
            .then(results =>
            {
                var lookupData = stateManager.getStore().getState().lookupData;
    
                lookupData.venues = results.venues;
                lookupData.tags = results.tags;
                lookupData.guests = results.guests;
                lookupData.freebieReasons = results.freebieReasons;
                lookupData.kitchenStationProfiles = results.kitchenStationProfiles;

                logger.info("Lookups data loaded successfully");
                this.state.stage = this.state.stage + 1;
                this.setState({});

            }, error =>
            {
                logger.error("Error occurred while loading lookup data. " + error, {}, error);
                this.setState({error: `Failed to load lookups data with error ${error}` });
            })
    }

    renderStaffLoadingStage()
    {
        var resources = [];
        resources.push(`${rmsApiProxyRetry.getOrgContextToUrl()}/hr/staff`);
        resources.push(`${rmsApiProxyRetry.getOrgContextToUrl()}/hr/staffRoles`);

        rmsApiProxyRetry.get(resources)
            .then(results =>
            {
                stateManager.getStore().getState().staffs = results[0];
                stateManager.getStore().getState().staffRoles = results[1];

                logger.info("Staff loaded successfully");
                this.state.stage = this.state.stage + 1;
                this.setState({});

            }, error =>
            {
                logger.error("Error occurred while loading staff. " + error, {}, error);
                this.setState({error: `Failed to load staff data with error ${error}` });
            });
    }

    renderPromotionsDataStage()
    {
        var resources = [];
        resources.push(`${rmsApiProxyRetry.getFranchisorOrgContextUrl()}/promotions/paymentTypes`);
        resources.push(`${rmsApiProxyRetry.getFranchisorOrgContextUrl()}/promotions/discountOffers`);
        
        rmsApiProxyRetry.get(resources)
            .then(results =>
            {
                var paymentTypes = [];
                var discountOffers = [];

                if (results != null && results.length == 2)
                {
                    if (results[0] != null)
                        paymentTypes = results[0];

                    if (results[1] != null)
                        discountOffers = results[1];
                }

                stateManager.getStore().getState().paymentTypes = paymentTypes;

                const property = commonUtility.getProperty();
                discountOffers.forEach(discountOffer =>
                    {
                        const propertyOverride = discountOffer.propertyDiscountOfferOverrides.find(x => x.propertyId == property.id);
                        if(propertyOverride)
                        {
                            discountOffer.isEnabled = !discountOffer.isEnabled;
                        }
                    })
                

                stateManager.getStore().getState().discountOffers = discountOffers;
                logger.info("Promotions loaded successfully");
                this.state.stage = this.state.stage + 1;
                this.setState({});

            }, error =>
            {
                logger.error("Error occurred while loading promotions. " + error, {}, error);
                this.setState({
                    error: error
                  });
            });        
    }
    
    renderMenuLoadingStage()
    {
        const baseUrl = rmsApiProxyRetry.getFranchisorOrgContextUrl();
        const resourceUrl = `${baseUrl}/menus`;

        rmsApiProxyRetry.get(resourceUrl, null, null, rmsApiProxyRetry.longOperationsTimeoutInSeconds)
            .then(results =>
            {
                stateManager.getStore().getState().menus = results;

                logger.info("Loaded menus");
                this.state.stage = this.state.stage + 1;
                this.setState({});

            }, error =>
            {
                logger.error("Error occurred while loading menus. " + error, {}, error);
                this.setState({
                    error: error
                  });
            });        
    }

    renderSnoozeLoadingStage()
    {
        rmsApiProxyRetry.get(`${rmsApiProxyRetry.getOrgContextToUrl()}/snooze`, null, null, rmsApiProxyRetry.longOperationsTimeoutInSeconds)
            .then(results =>
            {
                stateManager.getStore().getState().snoozes = results != null ? results : [];

                logger.info("Promotions loaded snooze data");
                this.state.stage = this.state.stage + 1;
                this.setState({});

            }, error =>
            {
                logger.error("Error occurred while loading snooze data. " + error, {}, error);
                this.setState({
                    error: error
                  });
            });        
    }

    renderFloatSessionLoadingStage()
    {
        const floatIdentifier = stateManager.getStore().getState().terminal.floatIdentifier;
        var resourceUrl = `${rmsApiProxyRetry.getOrgContextToUrl()}/floats`;
        if(!stringUtil.isStringNullOrEmpty(floatIdentifier))
            resourceUrl += `?identifier=${floatIdentifier}`;

        rmsApiProxyRetry.get(resourceUrl)
        .then(results =>
        {
            if (results != null && results.journals == null)
                results.journals = [];
                
            stateManager.getStore().getState().cashFloatPayload = results;

            
            logger.info("Float session loaded successfully.");
            this.state.stage = this.state.stage + 1;
            this.setState({});

        }, error =>
        {
            logger.error("Error occurred while loading float session. " + error, {}, error);
            this.setState({error: error});
        });            
    }

    renderAccountModulesLoadingStage()
    {
        const orgData = stateManager.getStore().getState().orgData;
        const franchisorId=  orgData.franchisor.id;
        const franchiseeId = orgData.franchisee.id;
        const propertyId = orgData.property.id;

        var resources = [`core/organizations/${franchisorId}/${franchiseeId}/${propertyId}/accounts/transactionAccounts`];
        resources = resources.concat(`core/organizations/${franchisorId}/accounts/chartOfAccounts`);
        resources = resources.concat(`core/organizations/${franchisorId}/${franchiseeId}/accounts/chartOfAccounts`);
        rmsApiProxyRetry.get(resources)
        .then(results =>
        {
            var accountsData = {}
            accountsData.transactionAccounts =  (results == null || results[0] == null) ? null : results[0];
            accountsData.categories = (results == null || results[1] == null) ? [] : results[1];
            accountsData.categories.push(...(results == null || results[2] == null) ? [] : results[2]);
            stateManager.getStore().getState().accountsData = accountsData;

            logger.info("Accounts Data loaded successfully");
            this.state.stage = this.state.stage + 1;
            this.setState({});
        }, error =>
        {
            logger.error("Error occurred while loading accounts data. " + error, {}, error);
            this.setState({error: error});
        });
    }

    renderOrderNumberFountainStage()
    {
        const orderNumberResource = `core/system/numberFountains/posOrderNumber/${stateManager.getStore().getState().terminalCode}/current`;

        rmsApiProxyRetry.get(orderNumberResource)
        .then(result =>
        {
            
            stateManager.getStore().getState().orderNumber = result.currentValue;
          
            logger.info("Order number fountain loaded");
            this.state.stage = this.state.stage + 1;
            this.setState({});
        },  error =>
        {
            logger.error("Error occurred while loading order number fountain. " + error, {}, error);
            this.setState({error: `Failed to load order number fountain with error ${error}` });
        });
    }

    renderLanguageLoadingStage()
    {
        translator.downloadLanguage(localizationUtils.getLanguage())
        .then(results =>
            {
                logger.info("Language loaded successfully");
                this.state.stage = this.state.stage + 1;
                this.setState({});
            }, error =>
            {
                logger.error("Error occurred while loading language. " + error, {}, error);
                this.setState({error: `Failed to load language data with error ${error}` });
            });
    }

    renderTerminalIntegrationsStage()
    {
        const terminal = stateManager.getStore().getState().terminal;
        const terminalIntegrationsResource = `${rmsApiProxyRetry.getOrgContextToUrl()}/terminals/${terminal.id}/integrations`;

        rmsApiProxyRetry.get(terminalIntegrationsResource)
            .then(results =>
            {
                stateManager.getStore().getState().terminal.integrations = results;
                stateManager.getStore().getState().creditCardIntegration = results.find(x => x.integrationType == constants.integrationTypes.cardPaymentManagement);

                logger.info("Terminal integrations loaded successfully");
                this.state.stage = this.state.stage + 1;
                this.setState({});
            },  error =>
            {
                logger.error("Error occurred while loading terminal integrations. " + error, {}, error);
                this.setState({error: `Failed to load terminal integrations with error ${error}` });
            });
    }

    renderCreditCardTerminalConnection()
    {
        try
        {
            creditCardTerminalDriver.connect(() =>
            {
                logger.info("Credit Card connected successfully.");
                this.state.stage = this.state.stage + 1;
                this.setState({});
            })
        }
        catch (error)
        {
            logger.error("Error occurred while connecting to credit card. " + error, {}, error);
            this.setState({error: `Failed to retrieve connected credit card terminal with error ${error}` });
        }
    }

    renderNotificationsLoadStage()
    {
        this.state.stage = this.state.stage + 1;
        this.setState({});
    }

    renderSalesLoadStage()
    {
        try
        {
            salesLoader.loadTodaysSalesAndSalesStatus()
            .then (() =>
                {
                    logger.info("Todays sales snapshot loaded successfully");
                    this.state.stage = this.state.stage + 1;
                    this.setState({});
                }, error =>
                {
                    logger.error("Error occurred while loading todays sales. " + error, {}, error);
                    this.setState({error: `Failed to load todays sales ${error}` });
                })

            return;
        }
        catch (error)
        {
            this.setState({error: `Failed to load todays sales ${error}` });
        }
    }

    renderUserNotifications()
    {
        var resourceUrl = `${rmsApiProxyRetry.getOrgContextToUrl()}/userNotifications`;
        rmsApiProxyRetry.get(resourceUrl)
            .then(results =>
            {
                if (results == null)
                    results = [];

                results.forEach(r =>
                {
                    r.isRead = true;
                });
                
                userNotificationsUtil.userNotifications = results;
                logger.info("User notifications loaded successfully.");
                this.state.stage = this.state.stage + 1;
                this.setState({});

            }, error =>
            {
                logger.error("Error occurred while loading float session. " + error, {}, error);
                this.setState({error: error});
            });            
    }

    renderNotificationChannelConnection()
    {
        try
        {
            notificationChannel.establishConnection()
            .then (() =>
                {
                    logger.info("Connected to notification channel.");
                    this.state.stage = this.state.stage + 1;
                    this.setState({});
                }, error =>
                {
                    logger.error("Error occurred while connecting to notification channel. " + error, {}, error);
                    this.setState({error: `Failed to connect to notification channel ${error}` });
                })

            return;
        }
        catch (error)
        {
            this.setState({error: `Failed to connect to notification channel ${error}` });
        }
    }

    renderSalesChannelConnection()
    {
        try
        {
            salesChannel.establishConnection()
            .then (() =>
                {
                    logger.info("Connected to sales channel.");
                    this.state.stage = this.state.stage + 1;
                    this.setState({});
                }, error =>
                {
                    logger.error("Error occurred while connecting to sales channel. " + error, {}, error);
                    this.setState({error: `Failed to connect to sales channel ${error}` });
                })

            return;
        }
        catch (error)
        {
            this.setState({error: `Failed to connect to sales channel ${error}` });
        }
    }

    loadSystemTheme()
    {
        var completeUrl = `/theme.json`;

        fetch(completeUrl, {cache: "no-store"})
        .then (async response =>
        {
            if (response.status != 200)
            {
                var errorMessage = `Error occurred while loading system theme. The returned code is ${response.status}`;
                logger.error(errorMessage);
                this.setState({
                                error: errorMessage
                              });
                return;
            }
            themeUtil.systemTheme = await response.json();
            this.state.stage = this.state.stage + 1;
            this.setState({});

        }, error =>
        {
            var errorMessage = `Error occurred while loading environment configuration ${error}`;
            logger.error(errorMessage, {}, error);
            this.setState({
                            error: errorMessage
                            });
            return;
        });
    }

    initializeHost()
    {
        this.initializeHostViaSearch();
        if (stringUtil.isStringNullOrEmpty(stateManager.getStore().getState().terminalCode))
            this.initializeHostViaHash();

        this.state.browserShellTypeAllowed = stringUtil.areStringSame(configurationManager.getConfig().environment, "local") ||
                                        stringUtil.areStringSame(configurationManager.getConfig().environment, "dev");

        if (!stringUtil.isStringNullOrEmpty(this.state.appId))
        {
            stateManager.getStore().getState().terminalCode = null;
            stateManager.getStore().getState().shellType = null;
            this.state.browserShellTypeAllowed = true;
        }

        if (stateManager.getStore().getState().renderingMode == null)
            stateManager.getStore().getState().renderingMode = uiConstants.DesktopRenderingMode;

        if (stateManager.getStore().getState().shellType == null)
            stateManager.getStore().getState().shellType = uiConstants.BrowserShellType;
    }

    renderTerminalProfileStage()
    {
        const resource = `${rmsApiProxyRetry.getOrgContextToUrl()}/terminals`;

        rmsApiProxyRetry.get(resource)
            .then(result =>
            {
                const terminal = result.find(x => x.code === stateManager.getStore().getState().terminalCode);

                stateManager.getStore().getState().terminals = result;
                stateManager.getStore().getState().terminal = terminal;
                stateManager.getStore().getState().terminalSettings = terminal.profile.settings;
                terminalSettingsUtils.initializeSettings();     
                
                stateManager.getStore().getState().currentStorefrontId = terminal.storefrontId;
                
                logger.info("Terminal profile loaded successfully");
                this.state.stage = this.state.stage + 1;
                this.setState({});
            },  error =>
            {
                logger.error("Error occurred while loading terminal profile. " + error, {}, error);
                this.setState({error: `Failed to load terminal profile with error ${error}` });
            });
    }

    renderVerifyConfigurations()
    {
        window.setTimeout(() =>
            {

                if (!commonUtility.getFranchisor().isEnabled)
                {
                    this.state.error = translator.getLabel("franchisor_account_is_marked_as_disabled");
                    this.setState({});
                    return;
                }

                if (!commonUtility.getFranchisee().isEnabled)
                {
                    this.state.error = translator.getLabel("franchisee_account_is_marked_as_disabled");
                    this.setState({});
                    return;
                }

                if (!commonUtility.getProperty().isEnabled)
                {
                    this.state.error = translator.getLabel("property_account_is_marked_as_disabled");
                    this.setState({});
                    return;
                }

                if (!commonUtility.isModuleSubscribed("POS"))
                {
                    this.state.error = translator.getLabel("does_not_have_pos_module_subscription");
                    this.setState({});
                    return;
                }

                this.state.stage = this.state.stage + 1;
                this.setState({});

            },1000);
    }

    renderPrintingTemplateLoadingStage()
    {
        const resourceUrl = `${rmsApiProxyRetry.getFranchisorOrgContextUrl()}/templates/printing`;
        
        rmsApiProxyRetry.get(resourceUrl)
            .then(results =>
            {
                if (results == null) results = [];
                results = results.filter(result => !result.isDisabled);

                stateManager.getStore().getState().printingTemplates = results;

                logger.info("Printing Templates loaded successfully.");
                this.state.stage = this.state.stage + 1;
                this.setState({});

            }, error =>
            {
                logger.error("Error occurred while loading Printing Templates. " + error, {}, error);
                this.setState({ error: error });
            });
    }

    initializeHostViaSearch()
    {
        if (this.props.location != null && this.props.location.search != null)
        {
            var parsedQueryString = queryString.parse(this.props.location.search);
            stateManager.getStore().getState().terminalCode = parsedQueryString.terminalCode;
            stateManager.getStore().getState().renderingMode = parsedQueryString.renderingMode;
            stateManager.getStore().getState().shellType = parsedQueryString.shellType;
            this.state.appId = parsedQueryString.appId;
        }
    }

    initializeHostViaHash()
    {
        if (window != null && window.location != null && !stringUtil.isStringNullOrEmpty(window.location.hash) && window.location.hash.includes("?"))
        {
            var rawQueryString = window.location.hash.split("?")[1];
            var parsedQueryString = queryString.parse(rawQueryString);
            stateManager.getStore().getState().terminalCode = parsedQueryString.terminalCode;
            stateManager.getStore().getState().renderingMode = parsedQueryString.renderingMode;
            stateManager.getStore().getState().shellType = parsedQueryString.shellType;
            this.state.appId = parsedQueryString.appId;
        }
    }
}

export default LoadingView;